import React, { useState } from 'react';
import { Collapse } from 'reactstrap';
import EditMyAccompModal from "./editProfileModals/editAccomp/EditMyAccompModal";

const OptionTray = () => (
    <div className="option-tray">
        <div className="icon primary"><i className="fa fa-eye"></i></div>
        <div className="icon"><i className="fa fa-arrow-up"></i></div>
        <div className="icon"><i className="fa fa-arrow-down"></i></div>
        <div className="icon danger"><i className="fa fa-trash"></i></div>
    </div>
)

const Awards = ({accomplishments}) => {
    if(!(accomplishments.length > 0)) return null
    return (
        <div className="v-stretch">
            <div className="v-align wd-pct-20 card-option" >
                <div className="card-list-header">Awards & Honours</div>
                <OptionTray />
            </div>
            <div className="flex-one b-l-border">
            {accomplishments.map((accomplishment) => {
                var className = accomplishment.invisible ? "card-option hiddenView" : "card-option"
                var date = accomplishment.date.toLocaleString('default', { month: 'short' }) + " " + accomplishment.date.getFullYear()
                return (
                <div className={className}>
                    <div>{accomplishment.title}, {date}
                        <i className="fas fa-certificate text-c-success mg-l-10 c-pointer"></i>
                    </div>
                    <div>{accomplishment.association}, {accomplishment.city}, {accomplishment.country}</div>
                    <div>{accomplishment.description}</div>
                    <OptionTray />
                </div>)
                })
            }
            </div>
        </div>
    )
}
const Projects = ({accomplishments}) => {
        if(!(accomplishments.length > 0)) return null
        return (
            <div className="v-stretch">
                <div className="v-align wd-pct-20 card-option" >
                    <div className="card-list-header">Projects</div>
                    <OptionTray />
                </div>
                <div className="flex-one b-l-border">
                {accomplishments.map((accomplishment) => {
                    var date = accomplishment.date.toLocaleString('default', { month: 'short' }) + " " + accomplishment.date.getFullYear()
                    return (
                    <div className="card-option">
                        <div>{accomplishment.title}, {date}
                            <i className="fas fa-certificate text-c-success mg-l-10 c-pointer"></i>
                        </div>
                        <div>{accomplishment.association}, {accomplishment.city}, {accomplishment.country}</div>
                        <div>{accomplishment.description}</div>
                        <OptionTray />
                    </div>)
                    })
                }
                </div>
            </div>
        )
    }
const Courses = ({accomplishments}) => {
    if(!(accomplishments.length > 0)) return null
    return (
        <div className="v-align mg-b-15">
            <div className="wd-pct-20" >
                <div className="card-list-header">Courses</div>
            </div>
            <div className="b-l-border">
            {accomplishments.map((accomplishment) => {
                var date = accomplishment.date.toLocaleString('default', { month: 'short' }) + " " + accomplishment.date.getFullYear()
                return (
                <div className="mg-l-15 mg-b-10">
                    <div>{accomplishment.title}, {date}
                        <i className="fas fa-certificate text-c-success mg-l-10 c-pointer"></i>
                    </div>
                    <div>{accomplishment.association}, {accomplishment.city}, {accomplishment.country}</div>
                    <div>{accomplishment.description}</div>
                </div>)
                })
            }
            </div>
        </div>
    )
}
const Events = ({accomplishments}) => {
    if(!(accomplishments.length > 0)) return null
    return (
        <div className="v-align mg-b-15">
            <div className="wd-pct-20" >
                <div className="card-list-header">Events</div>
            </div>
            <div className="b-l-border">
            {accomplishments.map((accomplishment) => {
                var date = accomplishment.date.toLocaleString('default', { month: 'short' }) + " " + accomplishment.date.getFullYear()
                return (
                <div className="mg-l-15 mg-b-10">
                    <div>{accomplishment.title}, {date}
                        <i className="fas fa-certificate text-c-success mg-l-10 c-pointer"></i>
                    </div>
                    <div>{accomplishment.association}, {accomplishment.city}, {accomplishment.country}</div>
                    <div>{accomplishment.description}</div>
                </div>)
                })
            }
            </div>
        </div>
    )
}
const Volunteer = ({accomplishments}) => {
    if(!(accomplishments.length > 0)) return null
    return (
        <div className="v-align mg-b-15">
            <div className="wd-pct-20" >
                <div className="card-list-header">Volunteer</div>
            </div>
            <div className="b-l-border">
            {accomplishments.map((accomplishment) => {
                // var date = accomplishment.date.toLocaleString('default', { month: 'short' }) + " " + accomplishment.date.getFullYear()
                return (
                <div className="mg-l-15 mg-b-10">
                    <div>{accomplishment.title}
                        <i className="fas fa-certificate text-c-success mg-l-10 c-pointer"></i>
                    </div>
                    <div>{accomplishment.association}, {accomplishment.city}, {accomplishment.country}</div>
                    <div>{accomplishment.description}</div>
                </div>)
                })
            }
            </div>
        </div>
    )
}
const Publications = ({accomplishments}) => {
    if(!(accomplishments.length > 0)) return null
    return (
        <div className="v-align mg-b-15">
            <div className="wd-pct-20" >
                <div className="card-list-header">Publications</div>
            </div>
            <div className="b-l-border">
            {accomplishments.map((accomplishment) => {
                var date = accomplishment.date.toLocaleString('default', { month: 'short' }) + " " + accomplishment.date.getFullYear()
                return (
                <div className="mg-l-15 mg-b-10">
                    <div>{accomplishment.title}, {date}
                        <i className="fas fa-certificate text-c-success mg-l-10 c-pointer"></i>
                    </div>
                    <div>{accomplishment.association}, {accomplishment.city}, {accomplishment.country}</div>
                    <div>{accomplishment.description}</div>
                </div>)
                })
            }
            </div>
        </div>
    )
}
const Conferences = ({accomplishments}) => {
    if(!(accomplishments.length > 0)) return null
    return (
        <div className="v-align mg-b-15">
            <div className="wd-pct-20" >
                <div className="card-list-header">Conferences</div>
            </div>
            <div className="b-l-border">
            {accomplishments.map((accomplishment) => {
                var date = accomplishment.date.toLocaleString('default', { month: 'short' }) + " " + accomplishment.date.getFullYear()
                return (
                <div className="mg-l-15 mg-b-10">
                    <div>{accomplishment.title}, {date}
                        <i className="fas fa-certificate text-c-success mg-l-10 c-pointer"></i>
                    </div>
                    <div>{accomplishment.association}, {accomplishment.city}, {accomplishment.country}</div>
                    <div>{accomplishment.description}</div>
                </div>)
                })
            }
            </div>
        </div>
    )
}
const Patents = ({accomplishments}) => {
    if(!(accomplishments.length > 0)) return null
    return (
        <div className="v-align mg-b-15">
            <div className="wd-pct-20" >
                <div className="card-list-header">Patents</div>
            </div>
            <div className="b-l-border">
            {accomplishments.map((accomplishment) => {
                var date = accomplishment.date.toLocaleString('default', { month: 'short' }) + " " + accomplishment.date.getFullYear()
                return (
                <div className="mg-l-15 mg-b-10">
                    <div>{accomplishment.title}, {date}
                        <i className="fas fa-certificate text-c-success mg-l-10 c-pointer"></i>
                    </div>
                    <div>{accomplishment.extrafield}</div>
                    <div>{accomplishment.extrafield2}</div>
                    <div>{accomplishment.extrafield3}</div>
                    <div>{accomplishment.association}, {accomplishment.city}, {accomplishment.country}</div>
                </div>)
                })
            }
            </div>
        </div>
    )
}

function MyAccomplishments(props) {
    const [collapse, setCollapse] = useState(false);
    const toggle = () => setCollapse(!collapse);
    const [ newPlanModal, setNewPlanModal ] = useState(false);
    const toggleNewPlanModal = () => setNewPlanModal(!newPlanModal);
    var { profile } = props.store
    var { accomplishments } = profile
    return (
    <div className="mg-t-20" >
        <div className="card" >
            <div className="card-header">
                <div className="card-header-left">
                    <h5>Accomplishments</h5>
                </div>
                <div className="card-header-right">
                    <ul className="row" >                        
                        <li><i className="far fa-edit" onClick={toggleNewPlanModal}></i></li>   
                        <li><i className={collapse ? "fa fa-chevron-down" : "fa fa-chevron-up"} onClick={toggle}></i></li>                                 
                        <EditMyAccompModal modal={newPlanModal} toggle={toggleNewPlanModal} accomplishments={accomplishments} />
                    </ul>                    
                </div>                
            </div> 
            <Collapse isOpen={!collapse}>   
            <div className="bo-trim" />
            <div className="card-block">
                <Awards accomplishments={accomplishments["awards"]}/>
                <div className="bo-card" ></div>
                <Projects accomplishments={accomplishments["projects"]}/>
                <div className="bo-card" ></div>
                <Courses accomplishments={accomplishments["courses"]}/>
                <hr className="mg-r-0" ></hr>  
                <Events accomplishments={accomplishments["events"]}/>
                <hr className="mg-r-0" ></hr>  
                <Volunteer accomplishments={accomplishments["volunteer"]}/>
                <hr className="mg-r-0" ></hr>  
                <Publications accomplishments={accomplishments["publications"]}/>
                <hr className="mg-r-0" ></hr>  
                <Conferences accomplishments={accomplishments["conferences"]}/>
                <hr className="mg-r-0" ></hr>  
                <Patents accomplishments={accomplishments["patents"]}/>     
            </div>
            </Collapse>
    </div>
    </div>
        
    );
  }

export default MyAccomplishments